var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("Breadcrumbs", {
        attrs: {
          breadcrumbs: [
            { title: "Список накладных", routeName: "InvoicesList" },
            { title: "Новая накладная" },
          ],
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 text-center" }, [
          _c(
            "div",
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: _vm.loading, color: _vm.color },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h5", [
                _c("span", { staticClass: "float-left new_invoice_header" }, [
                  _vm._v("Новая накладная"),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoiceType,
                        expression: "invoiceType",
                      },
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "250px" },
                    attrs: { disabled: !_vm.allowToEditInvoice },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.invoiceType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.updatedSelectedStores,
                      ],
                    },
                  },
                  _vm._l(Object.keys(_vm.invoiceTypes), function (type) {
                    return _vm.$currentRole === "admin" ||
                      _vm.invoiceTypes[type].allowToAll
                      ? _c("option", { domProps: { value: type } }, [
                          _vm._v(
                            _vm._s(_vm.invoiceTypes[type].title) +
                              "\n              "
                          ),
                        ])
                      : _vm._e()
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _vm.invoiceType == 1
                    ? [
                        _vm.sortedStores
                          ? _c("div", [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Склад получатель:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.invoice.store_in,
                                      expression: "invoice.store_in",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: !_vm.allowToEditInvoice },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.invoice,
                                        "store_in",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.sortedStores["income"],
                                  function (store, index) {
                                    return _c(
                                      "option",
                                      { domProps: { value: index } },
                                      [
                                        _vm._v(
                                          _vm._s(store) + "\n                  "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Валюта накладной:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice.currency_id,
                                  expression: "invoice.currency_id",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { disabled: !_vm.allowToEditInvoice },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.invoice,
                                    "currency_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.currencies, function (value, index) {
                              return _c(
                                "option",
                                { domProps: { value: index } },
                                [_vm._v(_vm._s(value) + "\n                  ")]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.invoiceType == 2
                    ? [
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Склад отправитель:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice.store_out,
                                  expression: "invoice.store_out",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { disabled: !_vm.allowToEditInvoice },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.invoice,
                                      "store_out",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.updateReceiverStore,
                                ],
                              },
                            },
                            _vm._l(
                              _vm.getSortedStores(_vm.sortedStores["shift"]),
                              function (store, index) {
                                return _c(
                                  "option",
                                  { domProps: { value: store.id } },
                                  [
                                    _vm._v(
                                      _vm._s(store.title) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.invoice.store_out
                          ? _c("div", { staticClass: "col-md-4" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Склад получатель:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.invoice.store_in,
                                      expression: "invoice.store_in",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { disabled: !_vm.allowToEditInvoice },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.invoice,
                                          "store_in",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.updateDeliveryDate,
                                    ],
                                  },
                                },
                                _vm._l(
                                  _vm.getSortedStores(
                                    _vm.sortedStores["shift"][
                                      _vm.invoice.store_out
                                    ].allowToSend.sub_value,
                                    true
                                  ),
                                  function (store, id) {
                                    return _vm.sortedStores["shift"][
                                      _vm.invoice.store_out
                                    ]
                                      ? _c(
                                          "option",
                                          { domProps: { value: store.id } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(store.title) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e()
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.invoiceType == 3
                    ? [
                        _c("div", [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Со склада:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice.store_out,
                                  expression: "invoice.store_out",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { disabled: !_vm.allowToEditInvoice },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.invoice,
                                    "store_out",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            _vm._l(
                              _vm.sortedStores["shift"],
                              function (store, index) {
                                return _c(
                                  "option",
                                  { domProps: { value: store.id } },
                                  [
                                    _vm._v(
                                      _vm._s(store.title) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Дата накладной:"),
                      ]),
                      _vm._v(" "),
                      _c("DateSelect", {
                        ref: "selectedDateComponent",
                        attrs: {
                          disabled: true,
                          useDisabledDates: false,
                          selectedDate: _vm.invoice.delivery_date,
                          onSelect: (date) =>
                            (this.invoice.delivery_date = date),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c("div", { staticClass: "form-group pt-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.invoice.use_for_autolist,
                          expression: "invoice.use_for_autolist",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ch_opt_1" },
                      domProps: {
                        checked: Array.isArray(_vm.invoice.use_for_autolist)
                          ? _vm._i(_vm.invoice.use_for_autolist, null) > -1
                          : _vm.invoice.use_for_autolist,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.invoice.use_for_autolist,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.invoice,
                                  "use_for_autolist",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.invoice,
                                  "use_for_autolist",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.invoice, "use_for_autolist", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label pointer",
                        attrs: { for: "ch_opt_1" },
                      },
                      [
                        _vm._v(
                          "Учитывать в резерве для всех статусов (только для\n                  автосписка)"
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "" } }, [_vm._v("Комментарий:")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoice.comment,
                        expression: "invoice.comment",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { rows: "2" },
                    domProps: { value: _vm.invoice.comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.invoice, "comment", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.invoice.type == 1 && _vm.invoiceDetailsVisibility
                  ? _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("InvoiceDiscount", {
                          attrs: { invoice: _vm.invoice },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.allowToEditInvoice
                  ? _c(
                      "div",
                      { staticClass: "col-md-12 mt-1" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Создать",
                            loading: _vm.loading,
                            color: _vm.$constants.PRIMARY_COLOR,
                            onClick: () => _vm.createInvoice(),
                            className: "btn btn-primary",
                            type: "button",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.invoiceDetailsVisibility
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    [
                      _c("OrderInvoiceDetails", {
                        ref: "invoiceDetails",
                        attrs: {
                          invoice: _vm.invoice,
                          editQtyByFact: false,
                          selectCostPrice:
                            +_vm.invoiceType === 2 &&
                            _vm.$AllStores[_vm.invoice.store_in]?.type_id === 2,
                          records: _vm.invoice.details,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _vm.invoiceStatuses
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.invoice.status,
                                  expression: "invoice.status",
                                },
                              ],
                              staticClass: "form-control",
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.invoice,
                                      "status",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.updateStatus,
                                ],
                              },
                            },
                            _vm._l(
                              _vm.sortedInvoiceStatuses,
                              function (status) {
                                return _c(
                                  "option",
                                  { domProps: { value: status.id } },
                                  [
                                    _vm._v(
                                      _vm._s(status.title) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    !_vm.invoiceSaved
                      ? _c(
                          "div",
                          { staticClass: "col-md-6 text-right" },
                          [
                            _c(
                              "vue-ladda",
                              {
                                attrs: {
                                  "button-class": "btn btn-success",
                                  "data-style": "zoom-in",
                                  loading: _vm.btn_save_loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.saveNewInvoice()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "Сохранить новую накладную\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }